import React from 'react';
import AboutSection from './components/AboutSection';
import BlogSection from './components/BlogSection';
import ClientSection from './components/ClientSection';
import ContactSection from './components/ContactSection';
import FeatureSection from './components/FeatureSection';
import Footer from './components/Footer';
import FooterAlt from './components/FooterAlt';
import Home1 from './components/Home1';
import Navbar from './components/Navbar';
import Preloader from './components/Preloader';
import PricingSection from './components/PricingSection';
import ServiceSection from './components/ServiceSection';


class Index1 extends React.Component {

  componentDidMount() {
        document.getElementById("main_navbar").classList.add("navbar-light");
  }

  render() {

    return (
      <React.Fragment>

        {/* preloader */}
        <Preloader />

        {/* Navigation Menu */}
        <Navbar />

        {/* HomeSection Menu */}
        <Home1 />

        {/* AboutSection Menu */}
        <AboutSection />

        {/* ServiceSection Menu */}
        <ServiceSection />

        {/* FeatureSection Menu */}
        <FeatureSection />

        {/* PricingSection Menu */}
        <PricingSection />

        {/* ClientSection Menu */}
        <ClientSection />

        {/* BlogSection Menu */}
        <BlogSection />

        {/* ContactSection Menu */}
        <ContactSection />

        {/* Footer Menu */}
        <Footer />

        {/* FooterAlt Menu */}
        <FooterAlt />

      </React.Fragment>

    );
  }
}

export default Index1;